import angular, { IPromise } from "angular";
import { IAlertRuleRecord } from "src/app/main/modules/alerts/_models/alerts.interfaces";

export interface IVideoAlertDetailData {

}

export class VideoAlertDetailService {
    static $inject = ["$q"];

    constructor(
        private readonly $q: angular.IQService) {
    }

    getAlertExport(record: IAlertRuleRecord): IPromise<string> {
        return this.getAlertData(record).then((data) => {
            return `${this.createAlertLabel(data)}`;
        }).catch((error) => {
            console.error("Error retrieving video alert detail: ", error);

            return null
        });
    }

    createAlertLabel(data: IVideoAlertDetailData) {
        return ``;
    }

    getAlertData(record: IAlertRuleRecord): IPromise<IVideoAlertDetailData> {
        var data: IVideoAlertDetailData = {};

        return this.$q.resolve(data)
    }


}
